import * as React from 'react';
import { FC, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonBase, IconButton } from '@mui/material';
import {
  SlEarphonesAlt,
  SlLogin,
  SlLogout,
  SlQuestion,
  SlUser,
} from 'react-icons/sl';
import MfDialog from '../components/UI/Dialog/MfDialog';
import MfAlert from '../components/UI/Alert/MfAlert';
import FeedbackDialog from '../components/Feedback/FeedbackDialog';
import TopBanner from '../components/Banners/TopBanner';

interface Props {
  title?: string;
}

const ResponsiveAppBar: FC<Props> = ({ title = 'Агентский кабинет' }) => {
  const [showSignOutDialog, setShowSignOutDialog] = useState<boolean>(false);
  const [showFeedbackDialog, setShowFeedbackDialog] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOutClick = () => {
    setShowSignOutDialog(true);
  };

  const handleFeedbackClick = () => {
    setShowFeedbackDialog(true);
  };

  const signOut = () => {
    localStorage.removeItem('user');
    window.location.href = '/lk/#/signin';
  };

  const navigateSignIn = () => {
    window.location.href = '/lk/#/signin';
  };

  const navigateProfile = () => {
    navigate('/profile');
  };

  const loggedIn = Boolean(localStorage.getItem('user'));

  return (
    <>
      <AppBar position="static" color="transparent" elevation={0}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <ButtonBase href="/">
              <Box
                sx={{
                  display: 'flex',
                  mr: 3,
                  alignItems: 'center',
                }}
              >
                <img style={{ height: '50px' }} src="img/logo.svg" alt="logo" />
              </Box>
            </ButtonBase>

            <Typography
              sx={{
                flexGrow: 1,
                lineHeight: 1,
                fontSize: { xs: 14, sm: 16 },
                mr: 3,
              }}
            >
              {title}
            </Typography>

            <Box sx={{ flexGrow: 0, gap: 1, display: 'flex' }}>
              {loggedIn && (
                <IconButton onClick={navigateProfile}>
                  <SlUser style={{ color: '#000000' }} />
                </IconButton>
              )}
              {loggedIn && (
                <IconButton onClick={handleFeedbackClick}>
                  <SlEarphonesAlt style={{ color: '#000000' }} />
                </IconButton>
              )}
              {!loggedIn && (
                <IconButton
                  href="https://www.moneyfriends.ru/faq.html"
                  target="_blank"
                >
                  <SlQuestion color="info" />
                </IconButton>
              )}
              {loggedIn && (
                <IconButton onClick={handleSignOutClick}>
                  <SlLogout style={{ color: '#000000' }} />
                </IconButton>
              )}
              {!loggedIn && location.pathname !== '/signIn' && (
                <IconButton onClick={navigateSignIn}>
                  <SlLogin style={{ color: '#000000' }} />
                </IconButton>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {loggedIn && (
        <MfDialog
          onClose={() => setShowSignOutDialog(false)}
          open={showSignOutDialog}
          title="Авторизация"
          onOk={signOut}
          okLabel="Выйти"
          maxWidth="sm"
          fullScreen={false}
        >
          <MfAlert severity="warning">
            Вы уверены, что хотите выйти из аккаунта?
          </MfAlert>
        </MfDialog>
      )}
      {loggedIn && (
        <FeedbackDialog
          open={showFeedbackDialog}
          onClose={() => setShowFeedbackDialog(false)}
        />
      )}
      {loggedIn && (
        <Container maxWidth="xl">
          <TopBanner />
        </Container>
      )}
    </>
  );
};
export default ResponsiveAppBar;
